export default function createOneUpChild(templateUrl, bindings){
    return {
        require : {
            oneUp: '^orderOneUp'
        },
        bindings,
        templateUrl($element, $attrs) {
            return $attrs.templateUrl || templateUrl;
        }
    };
}